// A formula component only counts as adopted when it credits something: null,
// undefined, '', and 0 are all "no adopted credit" for readiness purposes.
const noCredit = (value) => !(Number(value) > 0)

export function buildCashBalanceReadiness(plan = {}) {
  const cashBalance = plan.cashBalance || {}
  if (!cashBalance.enabled) return []
  const items = []
  const credits = Array.isArray(cashBalance.credits) ? cashBalance.credits : []
  if (!credits.length) {
    items.push({ code: 'cash-balance-credits-missing', severity: 'blocking', path: 'cashBalance.credits', capability: getPlanCapability('cashBalance.credits'), message: 'Add at least one benefit credit.' })
  }
  credits.forEach((credit, index) => {
    if (noCredit(credit?.formula?.value)) {
      items.push({ code: 'cash-balance-empty-formula', severity: 'blocking', path: `cashBalance.credits.${credit?.groupId || index}`, capability: getPlanCapability('cashBalance.credits'), message: `${credit?.groupLabel || 'A class'} has a credit of zero. Enter a percent of pay or a dollar amount.` })
    }
  })
  return items
}

export function buildPlanReadiness(plan = {}) {
  const items = buildCashBalanceReadiness(plan)
  const counts = Object.fromEntries(['blocking', 'unavailable', 'compliance-review', 'actuary-review', 'disclosure']
    .map((severity) => [severity, items.filter((item) => item.severity === severity).length]))
  return { items, counts, complete: counts.blocking === 0 }
}
import { getPlanCapability } from './planCapabilities.js'
